module.exports = __webpack_public_path__ + "static/img/9d.7952333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9d.jpg
// module id = cazg
// module chunks = 0